import { Box, TextField, Typography } from '@mui/material';

interface DealInputsProps {
    upfront: number;
    split: number;
    postRecoupSplit: number;
    onUpfrontChange: (value: number) => void;
    onSplitChange: (value: number) => void;
    onPostRecoupSplitChange: (value: number) => void;
}

export const DealInputs = ({
    upfront,
    split,
    postRecoupSplit,
    onUpfrontChange,
    onSplitChange,
    onPostRecoupSplitChange,
}: DealInputsProps) => {
    return (
        <Box>
            <Typography variant="subtitle2" gutterBottom>
                Artist's Offer
            </Typography>
            <Box display="flex" gap={2}>
                <TextField
                    label="Upfront Payment"
                    type="number"
                    size="small"
                    value={upfront}
                    onChange={(e) => onUpfrontChange(parseFloat(e.target.value) || 0)}
                    InputProps={{ startAdornment: '$' }}
                    fullWidth
                />
                <TextField
                    label="Backend Split"
                    type="number"
                    size="small"
                    value={split}
                    onChange={(e) => onSplitChange(parseFloat(e.target.value) || 0)}
                    InputProps={{ endAdornment: '%' }}
                    fullWidth
                    inputProps={{ min: 0, max: 100, step: 0.5 }}
                />
                <TextField
                    label="Post-Recoup Split"
                    type="number"
                    size="small"
                    value={postRecoupSplit}
                    onChange={(e) => onPostRecoupSplitChange(parseFloat(e.target.value) || 0)}
                    InputProps={{ endAdornment: '%' }}
                    fullWidth
                    inputProps={{ min: 0, max: 100, step: 0.5 }}
                />
            </Box>
        </Box>
    );
};
